import { ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * The `export function cn(inputs) {` function is exporting a function named `cn` that takes an input parameter and returns
 * a merged class string using the `clsx` and `tailwind-merge` libraries. The `cn` function is used to generate a combined
 * class string based on the input parameters provided, which can be used to apply multiple CSS classes to an element in a
 * React application.
 * 
 * @function
 * @name cn
 * @kind function
 * @param {any} inputs
 * @returns {any}
 * @exports
 */
export function cn(inputs) {
    return twMerge(clsx(inputs));
}